import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

const STEPS = [
  {
    title: 'stepper.ask_a_question'
  },
  {
    title: 'stepper.match_with_a_doctor'
  },
  {
    title: 'stepper.get_an_answer'
  }
]

export interface StepperContextProps {
  steps: {
    title: string
  }[]

  currentStepNumber: number
  setCurrentStepNumber: Dispatch<SetStateAction<number>>
}

export const StepperContext = createContext({} as StepperContextProps)

interface StepperProviderProps {
  children: ReactNode
}

export const StepperProvider = ({ children }: StepperProviderProps) => {
  const [currentStepNumber, setCurrentStepNumber] = useState<StepperContextProps['currentStepNumber']>(1)

  const value = {
    steps: STEPS,
    currentStepNumber,
    setCurrentStepNumber
  }

  return <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
}
